/**
 * this is the global service which handle the communication with the daisy backend and other classes inherit from this
 **/
export default class DaisyBaseService {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		this.$http = $injector.get('$http');
		this.$log = $injector.get('$log');
		this.$q = $injector.get('$q');
		this.ToastService = $injector.get('ToastService');
		this.appConfig = $injector.get('app.config');
		
		this.baseUrl = this.appConfig.api.url;
		this.eventName = this.appConfig.api.eventName;

		this.statusEnum = {
			OK: 'scOK'
		};
	}

	/**
	 * handle the response and transform it so we can work with it correctly
	 * @param {Object} response - the response from the doPost method
	 * @return {promise} with the transformed response
	 **/
	doResponseHandling(response){
		if (response.status == 200){
			let responseArray = response.data.result;
			if (0 in responseArray){
				let responseCode = responseArray[0];
				if (responseCode.Code == this.statusEnum.OK){
					if(1 in responseArray){
						return responseArray[1];
					}
				}
				else{
					this.ToastService.danger(responseCode.Text, "middle middle");
					return this.$q.reject(new Error(responseCode));
				}
			}
		}
		this.ToastService.danger('Ein unvorhergesehener Fehler ist aufgetreten.');
	}

	/**
	 * call the daisy backend
	 * @param {string} functionUrl - url to call
	 * @param {Object} data - data object
	 * @param {Object} config - config object
	 * @return {promise} with the transformed response
	 **/
	doPost(functionUrl, data, config = {}){
		let defaultConfig = {timeout: 30000};
		config = angular.merge({}, defaultConfig, config);
		//console.log('DaisyBaseService: ', functionUrl, data, config);
		return this.$http.post(this.baseUrl + functionUrl, data, config).then(
			(result) => {
				//console.log('doPost', result);
				return this.doResponseHandling(result);
			},
			(reason) => {
				this.ToastService.danger('Ein unvorhergesehener Fehler ist aufgetreten.');
				return this.$q.reject(new Error(reason));
			}
		);
	}
}
